import api from '@api/'
import {
  getModuleTranslator,
  getRootTranslator,
} from '@utils/get-module-translator'
import { transformRegisterData } from './helpers'
import configs from './config'

const __t = getModuleTranslator(configs.translationKey)
const __rootT = getRootTranslator()

/**
 * Register user with api
 * @param {object} data
 * @return {Promise<object>}
 */
export function registerTenantApi(data) {
  return api.post('/public/register', transformRegisterData(data), {
    notify: false,
  })
}

export function registerApi(data, aditionalParams = {}) {
  return api.post(
    '/public/requester',
    { ...data, captchaInfo: { ...aditionalParams } },
    {
      notify: false,
    }
  )
}

export function forgotPasswordApi(email, aditionalParams = {}) {
  return api.post(
    '/public/user/resetPassword',
    { email, captchaInfo: { ...aditionalParams } },
    {
      notify: false,
    }
  )
}

export function changePasswordApi(data, token) {
  return api.post('/public/user/changePassword', data, {
    params: {
      uarToken: token,
    },
    notification: {
      message: __rootT('success'),
      description: __t('password_reset_success'),
    },
  })
}

export function validatePasswordResetTokenApi(token) {
  return api.get('/public/validateToken', {
    params: {
      uarToken: token,
    },
    notify: false,
  })
}

export function getEmailTwoFactorAuthApi(token, notify = false) {
  return api.get(`/email/2fa`, {
    notify,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export function validateTwoFactorAuthApi(token, code) {
  return api.get(`/validate/2fa?validationcode=${encodeURIComponent(code)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export function changePasswordForRequesteApi(data, token) {
  return api.post(`user/requester/changeonetimepassword`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    notify: false,
  })
}

export function googleSSOLoginApi(token, provider = 'google') {
  return api.post(
    `public/sso/${provider}/login`,
    {
      token,
    },
    {
      notify: true,
    }
  )
}

export function getEnrollMfaApi(token) {
  return api.get(`/mfa/enrollment`, {
    notify: false,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export function validateMultiFactorAuthApi(token, code) {
  return api.get(`/validate/mfa?validationcode=${encodeURIComponent(code)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
export function validateMultiFactorAuthRecoveryApi(token, code) {
  return api.get(
    `/validate/mfa/recoverycode?validationcode=${encodeURIComponent(code)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

export function validateMultiFactorAuthResetApi(token, code) {
  return api.get(
    `/validate/mfaresetotp?validationcode=${encodeURIComponent(code)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

export function checkIsExcludeSSOUserAPi(email) {
  return api.get(
    `public/sso/checkisexcludessouser?useridentity=${encodeURIComponent(
      email
    )}`,
    {
      notify: true,
    }
  )
}

export function getSsoHandshakeApi(ssoHandshake) {
  return api.post(`/public/sso/handshake`, {
    ssoHandshake,
  })
}

export function getMtdtHandshakeTokenApi(token) {
  return api.get('socket/handshake-token')
}
